import axios from "axios";

const BASE = "/api/users";

export const getParents = () => axios.get(`${BASE}/parents`).then((r) => r.data);

export const getParentChildren = (parentId) =>
  axios.get(`${BASE}/parents/${parentId}/children`).then((r) => r.data);

export const inviteParent = (data) =>
  axios.post(`${BASE}/invite`, data).then((r) => r.data);

export const resendInvite = (userId) =>
  axios.post(`${BASE}/${userId}/resend-invite`).then((r) => r.data);

export const createParent = (data) =>
  axios.post(`${BASE}`, data).then((r) => r.data);

export const updateParent = (userId, data) =>
  axios.put(`${BASE}/${userId}`, data).then((r) => r.data);

export const deleteParent = (userId) =>
  axios.delete(`${BASE}/${userId}`).then((r) => r.data);
